// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"mainLayout--2rQoS","content":"content--2ZvG8","siteLayout":"siteLayout--3BeKB","siteLayoutBackground":"siteLayoutBackground--3xc7z","mainLogo":"mainLogo--aP6eO"};